export default __webpack_public_path__ + "static/media/water1.464f73a8.png";